/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Acknowledgement for persisted in-progress MCQ answer.
 */
export interface MCQAnswerUpdateResponse {
  saved?: boolean;
}
